import { createSlice } from "@reduxjs/toolkit";

export const lockerTimeLimitsSlice = createSlice({
	name: "lockerTimeLimits",
	initialState: {
		searchCriteria: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: "-1",
			partnerTypeId: "-1",
			partnerCategory: "-1",
		},
		lockerTimeLimitsData: {},
		lockerTypeList: [],
		partnerTypeList: [],
	},
	reducers: {
		changeCriteriaValue: (state, actions) => {
			const { name, value } = actions.payload;
			state.searchCriteria[name] = value;
		},
		setLockerTimeLimitsData: (state, actions) => {
			state.lockerTimeLimitsData = actions.payload;
		},
		getLockerTypeList: (state, actions) => {
			state.lockerTypeList = actions.payload;
		},
		getPartnertTypeList: (state, actions) => {
			state.partnerTypeList = actions.payload;
		},
		changeLockerTimeLimitsData: (state, actions) => {
			const { name, value } = actions.payload;
			let tempLockerTimeLimitsData = { ...state.lockerTimeLimitsData };
			tempLockerTimeLimitsData[name] = value;
			state.lockerTimeLimitsData = tempLockerTimeLimitsData;
		},
		clearLockerTimeLimitChanges: (state, actions) => {
			state.lockerTimeLimitsData = actions.payload;
		},

		resetLockerTimeLimits: (state) => {
			state.formData = {
				lockerTypeId: "-1",
				partnerTypeId: "-1",
			};
			state.searchCriteria = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerTypeId: "-1",
				partnerTypeId: "-1",
				partnerCategory: "-1",
			};
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getLockerTypeList,
	getPartnertTypeList,
	changeCriteriaValue,
	setLockerTimeLimitsData,
	changeLockerTimeLimitsData,
	clearLockerTimeLimitChanges,
	resetLockerTimeLimits,
} = lockerTimeLimitsSlice.actions;

export default lockerTimeLimitsSlice.reducer;
